import React from 'react';
import {
  ABOUT_PAGE_URL,
  CONTACT_PAGE_URL,
  SERVICES_PAGE_URL,
} from '../../utils/Routes';
import { Link } from 'react-router-dom';
// Images

function PlaySectionThree() {
  const items = [
    {
      id: 1,
      title: 'Fetishes & More',
      buttonText: 'Read more',
      buttonLink: ABOUT_PAGE_URL,
      content: (
        <>
          <p>
            BDSM is not just my passion—it is my way of life. In my fully
            equipped dungeon, I craft experiences that push boundaries,
            challenge limits, and leave my submissives craving more. From the
            sharp sting of my crop to the intoxicating feeling of total
            surrender, I revel in every moment of control. Pain and pleasure are
            mine to command, and every session is a carefully tailored journey
            into your deepest desires.
          </p>
          <p>
            Whether you are new to submission or a seasoned plaything, my
            dungeon is a sanctuary of discipline, indulgence, and exquisite
            torment. Step inside and feel the weight of true dominance—where
            obedience is rewarded, defiance is corrected, and your devotion
            fuels my pleasure.
          </p>
        </>
      ),
    },
    {
      id: 2,
      title: 'The Art of Feminization',
      buttonText: 'Learn more',
      buttonLink: SERVICES_PAGE_URL,
      content: (
        <>
          <p>
            Sissification, crossdressing, and gender transformation are
            beautiful expressions of submission, self-discovery, and ultimate
            vulnerability. I specialize in guiding my pets through this
            exhilarating transformation, whether they seek to embrace their
            inner femininity, refine their elegance, or submit to my vision of
            who they truly are.
          </p>
          <p>
            From makeup lessons and wardrobe selection to full immersive
            feminization sessions, I take pleasure in every step of your
            journey. Whether you dream of becoming my perfect little plaything
            or simply exploring the thrill of gender fluidity, I will mold you,
            train you, and perfect you into the vision I desire.
          </p>
        </>
      ),
    },
    {
      id: 3,
      title: 'Bespoke Sessions & Kinks',
      buttonText: 'Book session',
      buttonLink: CONTACT_PAGE_URL,
      content: (
        <>
          <p>
            My expertise extends far beyond domination—I curate personalized
            experiences tailored to your deepest fantasies. Whether you seek
            intense corporal punishment, intricate bondage, or mind-bending
            psychological control, every session is designed for maximum
            intensity and satisfaction.
          </p>
          <p>
            I also offer professional filming for those eager to capture their
            submission on camera, financial domination for those desperate to
            prove their devotion, and keyholding for those ready to surrender
            completely. The possibilities are endless—your desires are my
            playground, and your submission fuels my pleasure.
          </p>
        </>
      ),
    },
  ];

  return (
    <section className='container mx-auto px-6 mt-6 xl:mt-8 lg:px-4 mb-8'>
      <section className='mb-6 lg:mb-8'>
        <div className='angled_bg lg:w-1/2 pl-8 py-1'>
          <h2 className='text-3xl lg:text-4xl xl:text-5xl font-titleFont text-center md:text-left md:px-4'>
            Sessions & Fantasies
          </h2>
        </div>
      </section>

      <section className='grid lg:grid-cols-2 2xl:grid-cols-3 gap-8 lg:gap-8'>
        {items.map((item, index) => {
          // Cycle through bg-colour4, bg-colour5, bg-colour6 for the article
          const bgColors = ['bg-colour4', 'bg-colour5', 'bg-colour6'];
          const articleBg = bgColors[index % 3];
          const articleShadow = `shadow-${bgColors[index % 3].replace(
            'bg-',
            ''
          )}`;

          const shadowColor =
            index % 3 === 0
              ? 'shadow-colour4'
              : index % 3 === 1
              ? 'shadow-colour6'
              : 'shadow-colour5';

          // Ensure the h5 background is different from the article
          const h5Bg = bgColors[(index + 1) % 3]; // Shift the index by 1 to get a different color
          const h5Shadow = `shadow-${h5Bg.replace('bg-', '')}`;

          return (
            <article
              key={item.id}
              className={`${articleBg} grid grid-rows-a1a p-6 h-full shadow-cardShadowBold ${shadowColor} text-center md:text-left`}
            >
              <div className='text-center'>
                <h5
                  className={`font-titleFont font-semibold text-2xl lg:text-3xl mb-2 py-1 ${h5Bg} shadow-lg`}
                >
                  {item.title}
                </h5>
              </div>
              <div className='grid h-full gap-4 text-center mt-2 text-sm'>
                {item.content}
              </div>
              <div className='grid h-fit mt-6'>
                <Link
                  to={item.buttonLink}
                  className='blinking-button bg-colour2 active:scale-90 shadow-lg'
                  title={item.buttonText}
                  aria-label={item.buttonText}
                >
                  {item.buttonText}
                </Link>
              </div>
            </article>
          );
        })}
      </section>
    </section>
  );
}

export default PlaySectionThree;
